import * as THREE from 'three';

const CLOUD_RESOLUTION = HIGH_RES? 512:128; //128 on my computer //512 on PC

export class Cloud{
    constructor(){
        /**
         * SphereGeometry
         * radius,
         * widthSegments,
         * heightSegments,
         * phiStart, specify horizontal starting angle. Default is 0.
         * phiLength, specify horizontal sweep angle size. Default is Math.PI * 2.
         * thetaStart, specify vertical starting angle. Default is 0.
         * thetaLength, specify vertical sweep angle size. Default is Math.PI.
         */
        console.log('CLOUD_RESOLUTION :', CLOUD_RESOLUTION);
        const textureLoader = new THREE.TextureLoader();
        const geometry = new THREE.SphereGeometry( 0.5, CLOUD_RESOLUTION, CLOUD_RESOLUTION );
        const material = new THREE.MeshPhongMaterial();
        const cloudTexture = 'assets/images/cloud_2.png';

        material.map = textureLoader.load(cloudTexture);
        material.map.wrapS = THREE.RepeatWrapping;
        material.map.wrapT = THREE.RepeatWrapping;
        material.map.minFilter = THREE.NearestMipMapLinearFilter;

        // material.side = THREE.DoubleSide;
        material.transparent = true;
        material.depthWrite = false;
        material.depthTest = false;
        material.opacity = 1;
        this.mesh = new THREE.Mesh(geometry, material);
        /**
         * renderOrder : marker is always on top of the globe
         */
        this.mesh.renderOrder = 3;
    }

    move() {
      this.mesh.rotation.y += 0.03 * Math.PI / 180;
    }

    getMesh() {
        return this.mesh;
    }
}
